import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import { publish as defaultPublish, subscribe as defaultSubscribe, unsubscribe } from '@wh/message-bus';

var determineArguments = function determineArguments(topicOrObject, dataOrCallbackOfDefaultApi, isPublish) {
  var oldApiUsed = typeof topicOrObject === 'string';
  if (oldApiUsed) {
    return [topicOrObject, dataOrCallbackOfDefaultApi];
  }
  return [topicOrObject.topic, isPublish ? topicOrObject.data : topicOrObject.callback];
};

export var publish = function publish(topicOrObject, defaultApiData) {
  var args = determineArguments(topicOrObject, defaultApiData, true);
  return defaultPublish.apply(undefined, _toConsumableArray(args));
};

export var subscribe = function subscribe(topicOrObject, defaultApiCallback) {
  var args = determineArguments(topicOrObject, defaultApiCallback, false);
  return defaultSubscribe.apply(undefined, _toConsumableArray(args));
};

export { unsubscribe };
//# sourceMappingURL=patched-message-bus.js.map